import { Link } from "react-router-dom";

const footerNav = [
  { to: "/", label: "首页" },
  { to: "/story", label: "剧情进展" },
  { to: "/chapters", label: "追更话数" },
  { to: "/about", label: "关于我们" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-50 text-secondary-900">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-sword-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                斗罗<span className="text-primary-600">漫报</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-700">
              专注《斗罗大陆》漫画追更进度与最新剧情的信息聚合站。为读者整理主线进度、话数追踪与剧情速览，追更前先看进度，不迷路。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="https://x.com/"
                target="_blank"
                rel="nofollow noopener"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-800 transition-colors hover:bg-primary-500 hover:text-background-50"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-fill text-sm" />
              </a>
              <a
                href="https://weibo.com/"
                target="_blank"
                rel="nofollow noopener"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-800 transition-colors hover:bg-primary-500 hover:text-background-50"
                aria-label="微博"
              >
                <i className="ri-weibo-fill text-sm" />
              </a>
              <a
                href="mailto:contact@example.com"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-800 transition-colors hover:bg-primary-500 hover:text-background-50"
                aria-label="邮件"
              >
                <i className="ri-mail-fill text-sm" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-950">栏目导航</h3>
            <ul className="mt-4 space-y-3">
              {footerNav.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="inline-flex items-center gap-2 text-sm text-secondary-700 transition-colors hover:text-primary-600"
                  >
                    <span className="h-1 w-1 rounded-full bg-accent-500" />
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-950">关于本站</h3>
            <ul className="mt-4 space-y-3 text-sm text-secondary-700">
              <li>
                <Link to="/#faq" className="inline-flex items-center gap-2 hover:text-primary-600">
                  <i className="ri-question-line text-accent-600" /> 追更常见问题
                </Link>
              </li>
              <li>
                <Link to="/#subscribe" className="inline-flex items-center gap-2 hover:text-primary-600">
                  <i className="ri-mail-send-line text-accent-600" /> 追更提醒订阅
                </Link>
              </li>
              <li>
                <a href="mailto:contact@example.com" className="inline-flex items-center gap-2 hover:text-primary-600">
                  <i className="ri-mail-line text-accent-600" /> contact@example.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-200 pt-6 sm:flex-row">
          <p className="text-xs text-secondary-600">
            © {new Date().getFullYear()} 斗罗漫报 · 本站仅作追更进度与剧情整理交流，相关内容整理自公开信息，版权归原权利人所有。
          </p>
          <p className="text-xs text-secondary-600">追更不迷路 · 剧情速览站</p>
        </div>
      </div>
    </footer>
  );
}